<div class="supplier-authorize">
  <WizardSubscriptionBadge />
  {{#if this.authorized}}
    <ConditionalLoadingSpinner
      @condition={{this.unauthorizing}}
      @size="small"
    />
    <DButton
      class="deauthorize"
      @title="admin.wizard.subscription.deauthorize.title"
      @disabled={{this.unauthorizing}}
      @action={{this.deauthorize}}
    >
      {{i18n "admin.wizard.subscription.deauthorize.label"}}
    </DButton>
  {{else}}
    <DButton
      @icon="id-card"
      class="btn-primary"
      @label="admin.wizard.subscription.authorize.label"
      @title="admin.wizard.subscription.authorize.title"
      @action={{this.authorize}}
    />
  {{/if}}
</div>